import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import {HelperService} from '../../../Services/helper.service';


@Component({
  selector: 'app-google-reserve',
  templateUrl: './google-reserve.component.html',
  styleUrls: ['./google-reserve.component.css','../contacts/contacts.component.css','../aboutus/aboutus.component.css']
})


export class GoogleReserveComponent implements OnInit {
  @ViewChild('formGoogle') googleForm: NgForm;

  formData = {
    name: '',
    greserveEtE: false,
    greserveB: false
  }
  haveOneCheck: boolean = false;
  constructor(private helperService: HelperService) { }

  ngOnInit(): void {

  }
  onSubmit(){
    if (this.formData.greserveEtE || this.formData.greserveB){
      this.helperService.sendTurnOfGoogleReserveEmail(this.formData).subscribe(data => {
        this.googleForm.resetForm();
      });
    }
  }

}
